import { render, staticRenderFns } from "./CreatePMSCase.vue?vue&type=template&id=6210772b&scoped=true&"
import script from "./CreatePMSCase.vue?vue&type=script&lang=js&"
export * from "./CreatePMSCase.vue?vue&type=script&lang=js&"
import style0 from "./CreatePMSCase.vue?vue&type=style&index=0&id=6210772b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6210772b",
  null
  
)

export default component.exports